import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons'

const SearchInput = ({
  value,
  onChange,
  onEnter,
  onClear,
  placeholder,
  disabled = false
}) => {
  return (
    <div className="search-input-containter">
      <input
        value={value}
        onChange={onChange}
        onKeyDown={onEnter}
        className="round-search-input"
        placeholder={placeholder}
        disabled={disabled}
      />

      {!value && (
        <FontAwesomeIcon
          icon={faMagnifyingGlass}
          className="search-icon"
        />
      )}

      {value && !disabled && (
        <div
          className="round-search-input-x"
          onClick={onClear}
        >
          X
        </div>
      )}
    </div>
  )
}

export default SearchInput
